<template>
  <div id="app">
    <router-view ></router-view>
    <a href="#" data-target="html" class="scroll-to-target scroll-to-top"><i class="fa fa-angle-up"></i></a>
  </div>
</template>
<script>

  export default {
    name: 'index',
    data () {
      return {
      }
    },
    mounted () {
     
    },
    methods: {
  
    }
  
  }
</script>
<style lang="less">

  // .mobile_div {
  //   position: fixed;
  //   box-shadow: rgba(0, 0, 0, 0.15) 0px 0.1em 0.6em 0px, rgba(0, 0, 0, 0.09) 0px 0.2em 3.2em 0px;
  //   background: var(--notech-base);
  //   color: #fff;
  //   height: 44px;
  //   width: 4.4em;
  //   border-radius: 50%;
  //   font-size: 10px;
  //   margin-left: 0px;
  //   margin-top: 0px;
  //   z-index: 99;
  //   /* left: 331px; */
  //   right: 0;
  //   bottom: 249.2px;
  // }
  // .mobile_div_title{
  //   float: left;
  //   color: rgb(255, 255, 255);
  //   word-wrap: break-word;
  //   text-align: center;
  //   display: block;
  //   width: 2.17em;
  //   height: 2.67em;
  //   font-size: 1.2em;
  //   line-height: 1.33em;
  //   margin: 0.5em 0.75em;
  // }

  html, body, #app {
    height: 100%;
    margin: 0;
    padding: 0;
  }
</style>
